export default "__VITE_ASSET__3vpT6N_l__"